
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/engineering-solutions",
      function () {
        return require("private-next-pages/engineering-solutions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/engineering-solutions"])
      });
    }
  